module.exports = __webpack_public_path__ + "img/9788982181313.78a98991.jpg";